export const lowerCase = function(string){
    return string.toLowerCase().replace(' ', '')
}
// export const numFormat = function(number){
//     let formatter = new Intl.NumberFormat(locale);
//     return formatter.format(number);
// }
